import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';

interface QueryStaleDataWarningProps {
  message?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

const QueryStaleDataWarning: React.FC<QueryStaleDataWarningProps> = ({
  message = 'Showing last synced data.',
  onRetry,
  retryLabel = 'Retry',
}) => {
  return (
    <Box display="flex" flexDirection="column" gap={1} width="100%">
      <Alert severity="warning">
        <Typography variant="body2">{message}</Typography>
      </Alert>
      {onRetry ? (
        <Box>
          <Button size="small" variant="outlined" onClick={onRetry}>
            {retryLabel}
          </Button>
        </Box>
      ) : null}
    </Box>
  );
};

export default QueryStaleDataWarning;